import {ChangeDetectorRef, Component} from '@angular/core';

import {AlertController, NavController, Platform} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {ILocalNotificationEvery, LocalNotifications} from '@ionic-native/local-notifications/ngx';
import {UserService} from './provider/user-service/user.service';
import {Subscription} from 'rxjs';
import {MessageService} from './provider/message-service/message.service';
import {ApiService} from './provider/api-service/api.service';
import {IAPProduct, InAppPurchase2} from '@ionic-native/in-app-purchase-2/ngx';
import {IAPService} from './provider/iap/iap.service';
import {StorageService} from './provider/storage-service/storage.service';
import {ErrorService} from './provider/error-service/error.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {

    subscription: Subscription;

    productIds: Array<string>;
    products: IAPProduct[] = [];
    isSubscribed = false;

    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private userService: UserService,
        private localNotifications: LocalNotifications,
        private msgService: MessageService,
        private api: ApiService,
        private store: InAppPurchase2,
        private ref: ChangeDetectorRef,
        private alertCtrl: AlertController,
        private iapService: IAPService,
        private navCtrl: NavController,
        private storageService: StorageService,
        private errorService: ErrorService,
        private router: Router) {

        this.initializeApp();
        this.subscription = this.msgService.getMessages().subscribe((subscription) => {

            if (subscription.message.context === 'set:settings' && subscription.message.change) {
                this.platform.ready().then(() => {
                    this.setNotifications();
                });
            }
        });
    }

    initializeApp() {
        console.log('### initializeApp ###: ');
        this.platform.ready().then(() => {

            // read GET Params from iFrame URL
            try {
                const parentFrame = window.parent.document.getElementById('symptoFrame');
                const getParamsString = parentFrame.getAttribute('src').split('?');
                const queryString = getParamsString[1];

                if (queryString.includes('tab=messages')) {
                    const urlParams = new URLSearchParams(queryString);
                    let navCallRoute = '';
                    if (urlParams.get('tab') === 'messages') {
                        navCallRoute = 'tabs/contact';
                    } else {
                        navCallRoute = 'tabs/home';
                    }

                    this.storageService.setToken(urlParams.get('token'));
                    this.storageService.setNavigationCall(navCallRoute);

                } else {
                    this.storageService.setIframeParams(getParamsString[1]);
                }

            } catch (e) {
                this.errorService.consoleLog('AppComponent:initializeApp - GET Parameter from iFrame', 'Application does not run in an iFrame.');
            }


            if (!(this.platform.is('mobileweb') || this.platform.is('desktop'))) {

                this.statusBar.styleDefault();
                this.splashScreen.hide();
                this.setNotifications();

                this.store.verbosity = this.store.QUIET;

                // Get the List of ProductIds from API
                this.api.getProductsListLocal().subscribe(
                    (response) => {

                        if (this.platform.is('android')) {
                            this.productIds = response.body.sympto.productIds;

                            try {
                                if (this.productIds.length > 0) {

                                    this.iapService.registerProducts(this.productIds);
                                    this.iapService.setupStoreListeners(this.productIds, false);

                                    this.store.refresh();

                                    // Get the real product information
                                    this.store.ready(() => {
                                        this.iapService.products = this.store.products;
                                        this.ref.detectChanges();
                                    });
                                }

                            } catch (e) {
                                this.errorService.consoleError('AppComponent:initializeApp:getProductsListLocal', 'getProductsList tryCatch error', e);
                            }
                        } else if (this.platform.is('ios')) {
                            this.productIds = response.body.sympto.iOSproductIds;

                            try {
                                if (this.productIds.length > 0) {

                                    this.iapService.registerProducts(this.productIds);
                                    this.iapService.setupStoreListeners(this.productIds, true);

                                    this.store.refresh();

                                    // Get the real product information
                                    this.store.ready(() => {

                                        this.iapService.products = this.store.products;

                                        // ios liefert Abo-Gruppe ebenfalls mit, welche hier herausgefiltert wird
                                        this.iapService.products = this.iapService.products.filter(function (obj) {
                                            return obj.price !== null;
                                        });

                                        this.ref.detectChanges();
                                    });
                                }

                            } catch (e) {
                                this.errorService.consoleError('AppComponent:initializeApp:getProductsListLocal', 'getProductsList tryCatch error', e);
                            }
                        }

                    }, (error) => {
                        this.errorService.consoleError('AppComponent:initializeApp:getProductsListLocal', 'getProductsList subscribe error', error);
                    });

            } else {
                // Navigate to Login
                // User is in Browser
                console.log('### BIN IM  BROWSER ####');
                this.navCtrl.navigateRoot('/login');
            }

            this.platform.resume.subscribe(async () => {
                console.log('### resume ###');
                this.localNotifications.cancelAll()
                    .then((data) => {
                        console.log('this.localNotifications.cancel: ', data);
                    });
            });
        });

    }

    setNotifications() {

        this.localNotifications.isPresent(1)
            .then((present) => {
                this.errorService.consoleLog('AppComponent:setNotifications', 'Notification isPresent', present);
            });

        this.localNotifications.isScheduled(1)
            .then((present) => {
                this.errorService.consoleLog('AppComponent:setNotifications', 'Notification isScheduled', present);
            });

        this.localNotifications.isTriggered(1)
            .then((present) => {
                this.errorService.consoleLog('AppComponent:setNotifications', 'Notification isTriggered', present);
            });

        const notificationSettings: any = this.userService.getLocalNotificationSettings();
        try {
            if (notificationSettings && typeof notificationSettings.text !== 'undefined') {
                const options: any = {
                    id: 1,
                    text: notificationSettings.text,
                    trigger: {
                        every: {
                            hour: parseInt(notificationSettings.hour, 10),
                            minute: parseInt(notificationSettings.minute, 10),
                        },
                        count: 1
                    },
                    sound: notificationSettings.sound,
                    badge: '1',
                    foreground: true
                };

                if (notificationSettings.notifications) {
                    this.errorService.consoleLog('AppComponent:setNotifications', 'notificationSettings.notifications');
                    this.localNotifications.schedule(options);
                } else {
                    this.errorService.consoleLog('AppComponent:setNotifications', 'localNotifications.cancel');
                    this.localNotifications.cancel(1)
                        .catch((e) => {
                            this.errorService.consoleLog('AppComponent:setNotifications', 'cancel catch error', e);
                        })
                        .then((cancel) => {
                            this.errorService.consoleLog('AppComponent:setNotifications', 'cancel', cancel);
                        });
                }

            }
        } catch (e) {
            this.errorService.consoleLog('AppComponent:setNotifications', 'error', e);
        }

    }
}
